<template>
  <div class="issue-panel">
    <!-- 期刊封面图 -->
    <img
      v-if="issueList.length > 0"
      class="image_19"
      referrerpolicy="no-referrer"
      :src="issueList[hoverIndex].img"
      alt="期刊封面"
      @click="showDetail(issueList[hoverIndex])"
    />
    <!-- 月份选择器 -->
    <div class="box_66 flex-col">
      <a class="text-wrapper_4 flex-col" href="/magazine"><span class="text_26">更多</span></a>
      <div class="issue-gap"></div>

      <div class="issue-list">
        <div
          v-for="(issue, idx) in issueList"
          :key="idx"
          class="issue-item"
        >
          <!-- 年份 + 箭头：仅在当前 hover 的月份项上方显示，占据文档流空间 -->
          <div
            v-if="hoverIndex === idx"
            class="year-arrow-wrap"
          >
            <div class="text-wrapper_5 flex-col">
              <span class="text_28">{{ issue.year || currentYear }}</span>
            </div>
            <div class="issue-arrow flex-col">
              <span class="issue-arrow-icon">▼</span>
            </div>
          </div>
          <div
            class="text-wrapper_6 flex-col issue-month-item"
            :class="{ 'issue-month-active': hoverIndex === idx, 'issue-month-last': idx === issueList.length - 1 }"
            @mouseenter="hoverIndex = idx"
            @click="showDetail(issue)"
          >
            <span class="text_29">{{ issue.month }}</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import request from '../api/request'

export default {
  name: 'IssuePanel',
  data() {
    return {
      issueList: [],
      hoverIndex: 0,
      currentYear: new Date().getFullYear()
    }
  },
  created() {
    this.fetchIssueList()
  },
  methods: {
    // 加载当前年份的期刊列表
    async fetchIssueList() {
      try {
        const res = await request.post('/api/emagazine/listNS5', {})
        const data = res.data || {}
        const list = Array.isArray(data) ? data : (data.rows || data.list || data.records || [])
        this.issueList = list.map(item => ({
          id: item.id,
          emagazineCode: item.emagazineCode || '',
          month: String(item.issueNumber).padStart(2, '0'),
          img: item.cover,
          year: item.year,
          name: item.name || item.title || `第${item.issueNumber}期`
        }))
        // 默认 hover 最上方一期
        this.hoverIndex = 0
      } catch (e) {
        console.error('期刊列表加载失败', e)
      }
    },
    // 显示期刊详情弹层
    showDetail(issue) {
      if (!issue || !issue.emagazineCode) return
      window.open(`/magazine/viewer?emagazineCode=${issue.emagazineCode}`, '_blank')
    }
  }
}
</script>

<style scoped>
/* 月份选择器 + 封面图容器 */
.issue-panel {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0;
  width: 316px;
  flex-shrink: 0;
}

.issue-panel .image_19 {
  position: relative;
  left: auto;
  top: auto;
  width: 284px;
  height: 366px;
  object-fit: cover;
  border-radius: 0;
  flex-shrink: 0;
  display: block;
  cursor: pointer;
}

.issue-panel .box_66 {
  min-height: 366px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 36px;
}

/* 月份列表 */
.issue-list {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

/* 单个月份项容器 */
.issue-item {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 6px;
}

.issue-item:last-child {
  margin-bottom: 0;
}

/* 年份 + 箭头：在文档流中占据空间 */
.year-arrow-wrap {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 36px;
}

/* 更多 */
.text-wrapper_4 {
  background-color: rgba(51, 51, 51, 1);
  border-radius: 0 4px 4px 0;
  height: 29px;
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.text_26 {
  color: rgba(255, 255, 255, 1);
  font-size: 13px;
  font-family: Microsoft YaHei-Regular;
  white-space: nowrap;
  line-height: 1;
  text-align: center;
}

/* 年份 */
.text-wrapper_5 {
  background-color: rgba(51, 51, 51, 1);
  height: 20px;
  width: 36px;
  border-radius: 0 6px 6px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text_28 {
  color: rgba(255, 255, 255, 1);
  font-size: 13px;
  font-family: Microsoft YaHei-Regular;
  white-space: nowrap;
  line-height: 1;
  text-align: center;
}

/* 更多与年份之间的空白 */
.issue-gap {
  height: 8px;
  width: 32px;
  flex-shrink: 0;
}

/* 年份与月份之间的箭头 */
.issue-arrow {
  width: 32px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: -7px;
  z-index: 999;
}

.issue-arrow-icon {
  color: rgba(51, 51, 51, 1);
  font-size: 10px;
  line-height: 1;
}

/* 月份框 */
.text-wrapper_6 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 0 6px 6px 0;
  height: 57px;
  border: 1px solid rgba(206, 206, 206, 1);
  border-left: none;
  margin-top: 0;
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 最后月份框右上右下都有圆角 */
.issue-month-last {
  border-radius: 0 6px 6px 0;
}

.text_29 {
  color: rgba(102, 102, 102, 1);
  font-size: 16px;
  font-family: Microsoft YaHei-Regular;
  text-align: center;
  line-height: 1;
}

/* 期刊列表项交互 */
.issue-month-item {
  cursor: pointer;
  transition: all 0.15s;
}

.issue-month-item:hover,
.issue-month-active {
  background-color: rgba(175, 0, 14, 1);
  border-color: rgba(175, 0, 14, 1);
  margin-top: -12.8px;
}

.issue-month-item:hover .text_29,
.issue-month-active .text_29 {
  color: rgba(255, 255, 255, 1);
  font-weight: bold;
}
</style>
